import { HandLandmarker, FilesetResolver } from '@mediapipe/tasks-vision';

let handLandmarker = null;

export async function initHandDetection() {
  if (handLandmarker) return handLandmarker;
  const fileset = await FilesetResolver.forVisionTasks(
    'https://cdn.jsdelivr.net/npm/@mediapipe/tasks-vision/wasm'
  );
  handLandmarker = await HandLandmarker.createFromOptions(fileset, {
    baseOptions: {
      modelAssetPath: 'https://storage.googleapis.com/mediapipe-assets/hand_landmarker.task',
    },
    runningMode: 'VIDEO',
    numHands: 1,
  });
  return handLandmarker;
}

export function getFingerDirection(landmarks, threshold = 0.14) {
  if (!landmarks || landmarks.length < 9) return null;
  const tip = landmarks[8];
  const base = landmarks[5];
  const dx = tip.x - base.x;
  const dy = tip.y - base.y;
  let direction = null;
  if (Math.abs(dx) > Math.abs(dy) && Math.abs(dx) > threshold)
    direction = dx > 0 ? 'right' : 'left';
  else if (Math.abs(dy) > Math.abs(dx) && Math.abs(dy) > threshold)
    direction = dy > 0 ? 'down' : 'up';
  return direction;
}

const distance3d = (a, b) => {
  if (!a || !b) return 0;
  const dx = (a.x ?? 0) - (b.x ?? 0);
  const dy = (a.y ?? 0) - (b.y ?? 0);
  const dz = (a.z ?? 0) - (b.z ?? 0);
  return Math.sqrt(dx * dx + dy * dy + dz * dz);
};

export function getPalmOpenState(landmarks, options = {}) {
  if (!Array.isArray(landmarks) || landmarks.length < 21) return null;

  const {
    minExtended = 3,
    extensionRatio = 1.15,
    minDelta = 0.04,
  } = options;

  const wrist = landmarks[0];
  if (!wrist) return null;

  const fingers = [
    { tip: 8, mcp: 5 },
    { tip: 12, mcp: 9 },
    { tip: 16, mcp: 13 },
    { tip: 20, mcp: 17 },
  ];

  let extendedCount = 0;
  for (const finger of fingers) {
    const tip = landmarks[finger.tip];
    const mcp = landmarks[finger.mcp];
    if (!tip || !mcp) continue;

    const tipDist = distance3d(tip, wrist);
    const mcpDist = distance3d(mcp, wrist);
    if (tipDist >= (mcpDist * extensionRatio) && (tipDist - mcpDist) >= minDelta) {
      extendedCount += 1;
    }
  }

  return {
    isOpen: extendedCount >= minExtended,
    extendedCount,
  };
}
